document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const image = gallery.querySelector('#almc-gallery-image');
    const source = gallery.querySelector('source[type="image/webp"]');
    const figure = gallery.querySelector('#zoomFig');
    const buttons = [...gallery.querySelectorAll('[data-gallery-index]')];
    const announcement = gallery.querySelector('[data-gallery-announcement]');
    if (!image || !buttons.length) return;

    let current = 0;
    const select = (index, focus = false) => {
        const button = buttons[index];
        if (!button || button.disabled) return;
        current = index;
        if (source) source.srcset = button.dataset.galleryWebp || '';
        image.srcset = button.dataset.galleryJpg || '';
        image.src = button.dataset.gallerySrc;
        image.alt = button.getAttribute('aria-label');
        image.style.setProperty('--almc-gallery-image-max', `${Number(button.dataset.galleryMax) || 400}px`);
        image.style.transformOrigin = 'center center';
        figure.classList.remove('zooming');
        buttons.forEach((item, position) => {
            item.setAttribute('aria-pressed', String(position === index));
            item.tabIndex = position === index ? 0 : -1;
        });
        if (announcement) announcement.textContent = image.alt;
        if (focus) {
            button.focus({ preventScroll: true });
            button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
    };

    buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(index));
        button.addEventListener('keydown', (event) => {
            const enabled = buttons.map((item, i) => item.disabled ? -1 : i).filter((i) => i >= 0);
            const position = enabled.indexOf(index);
            let next;
            if (event.key === 'ArrowRight') next = enabled[(position + 1) % enabled.length];
            if (event.key === 'ArrowLeft') next = enabled[(position - 1 + enabled.length) % enabled.length];
            if (event.key === 'Home') next = enabled[0];
            if (event.key === 'End') next = enabled[enabled.length - 1];
            if (next === undefined) return;
            event.preventDefault();
            select(next, true);
        });
    });

    image.addEventListener('error', () => {
        if (current === 0) return;
        const restoreFocus = document.activeElement === buttons[current];
        buttons[current].disabled = true;
        select(0, restoreFocus);
    });
});
